// extracted by mini-css-extract-plugin
module.exports = {"text-area":"CaptionEditModal--text-area--38nhe","textArea":"CaptionEditModal--text-area--38nhe"};